'use client';

import { c as _c } from "react/compiler-runtime";
import { resolveProviderIcon } from '@/components/icons/provider-icons';
import type { TaskModelSeries } from '@/domains/pages/ai-spend/utils/map-ai-spend-task-model';
import { cn } from '@/utils/shad';
type SpendModelLegendProps = {
  series: TaskModelSeries[];
  className?: string;
};
export function SpendModelLegend(t0) {
  const $ = _c(7);
  const {
    series,
    className
  } = t0;
  if (series.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("no-scrollbar flex max-w-full min-w-0 flex-nowrap items-center gap-4 overflow-x-auto scroll-pl-2 pl-2 text-xs whitespace-nowrap text-muted-foreground", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== series) {
    t2 = series.map(_temp);
    $[2] = series;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1} data-testid="spend-model-legend">{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(item) {
  const ProviderIcon = resolveProviderIcon(item.provider);
  const providerLabel = item.provider ?? "Unknown provider";
  return <span key={item.key} className="inline-flex shrink-0 items-center gap-1.5"><span className="size-3 shrink-0" title={providerLabel} aria-label={providerLabel}><ProviderIcon className="size-3" aria-hidden={true} /></span><span className="size-2 shrink-0 rounded-[2px]" style={{
      backgroundColor: item.color
    }} aria-hidden={true} />{item.label}</span>;
}